import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import Icon from 'app/assets/icon/icon';
// import ReactHtmlParser from 'react-html-parser';
// import { ModalContext } from 'app/components/modal';
import React from 'react';
import StoreItemActions from './StoreItemActions';
import defaultClasses from '../../searchResults.module.css';
import RightColumn from './RightColumn';

var StoreItem = function StoreItem(_ref) {
  var store = _ref.store,
      shownStores = _ref.shownStores,
      setShownStores = _ref.setShownStores,
      setNewPosition = _ref.setNewPosition,
      calculateRoute = _ref.calculateRoute,
      coordinates = _ref.coordinates,
      predefinedCoordinates = _ref.predefinedCoordinates,
      index = _ref.index,
      onGetDirection = _ref.onGetDirection;
  return React.createElement("li", {
    key: "store-locator-list-of-location-id-".concat(store.store_id),
    className: "cursor-pointer ".concat(defaultClasses.storeItem, " ").concat(shownStores[store.store_id] ? defaultClasses.active : ''),
    onClick: function onClick(e) {
      setShownStores(_objectSpread(_objectSpread({}, shownStores), {}, _defineProperty({}, store.store_id, !shownStores[store.store_id])));
      setNewPosition({
        lat: store.lat,
        lng: store.lng
      });
    }
  }, React.createElement("div", {
    className: defaultClasses.storeItemNumber
  }, React.createElement("p", null, index + 1)), React.createElement("div", {
    className: 'block sm_flex sm_items-start w-full sm_justify-between'
  }, React.createElement("div", {
    className: defaultClasses.storeItemContent
  }, React.createElement("div", {
    className: "".concat(defaultClasses.storeTitleWrapper)
  }, React.createElement("h6", {
    className: defaultClasses.storeName
  }, store.name)), React.createElement("div", {
    className: "".concat(defaultClasses.storeItemDetails, " grid gap-[0.5rem]")
  }, React.createElement("div", {
    className: "store-street-wrapper"
  }, React.createElement("div", null, React.createElement("p", {
    className: "store-street"
  }, store.street), React.createElement("p", {
    className: "store-city-zip"
  }, store.city, ", ", store.state, ", ", store.zip), React.createElement("div", {
    className: "store-phone-wrapper ".concat(defaultClasses.phone)
  }, React.createElement("a", {
    href: "tel:".concat(store.telephone)
  }, store.telephone))))), React.createElement(StoreItemActions, {
    store: store,
    calculateRoute: calculateRoute,
    coordinates: coordinates,
    predefinedCoordinates: predefinedCoordinates,
    onGetDirection: onGetDirection // showStoreLocatorModal={showStoreLocatorModal}

  })), React.createElement(RightColumn, {
    group: store.group
  })));
};

export default StoreItem;